<template>
  <div v-if="fraudRating">
    <i-badge
      :id="'fraud-rating-badge-' + customerId"
      class="fraud-rating-badge"
      :label="badgeProperties.label"
      :colour="badgeProperties.colour"
      :icon="badgeProperties.icon"
      :aria-label="badgeProperties.label.toLowerCase()"
      outline
      has-leading-icon
    ></i-badge>
    <i-tooltip
      :target="'#fraud-rating-badge-' + customerId"
      :title="tooltipProperties.title"
      :description="tooltipProperties.description"
      :alignment="iTooltipAlignmentMode.BOTTOM_MIDDLE"
      link-text="Learn more"
      @link-clicked="goToArticle"
    ></i-tooltip>
  </div>
</template>

<script>
import * as customerFraudRatingOptions from '@/constants/customerFraudRating';
import {
  iBadge,
  iBadgeColours,
  iTooltip,
  iTooltipAlignmentMode,
} from '@inscribe/signal';

export default {
  name: 'CustomerFraudRating',
  components: {
    iBadge,
    iTooltip,
  },
  props: {
    fraudRating: {
      type: String,
      required: false,
      default: null,
    },
    customerId: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      options: customerFraudRatingOptions,
      iBadgeColours,
      iTooltipAlignmentMode,
    };
  },
  computed: {
    badgeProperties() {
      const properties = {
        label: '',
        colour: '',
        icon: '',
      };

      switch (this.fraudRating) {
        case this.options.HIGH_RISK:
          properties.label = 'High Risk';
          properties.colour = iBadgeColours.ERROR;
          properties.icon = 'small-alert-triangle';
          break;
        case this.options.LOW_RISK:
          properties.label = 'Low Risk';
          properties.colour = iBadgeColours.SUCCESS;
          properties.icon = 'small-check-circle';
          break;
        case this.options.UNCERTAIN_RISK:
          properties.label = 'Uncertain Risk';
          properties.colour = iBadgeColours.NEUTRAL;
          properties.icon = 'small-help-question-circle';
          break;
      }

      return properties;
    },
    tooltipProperties() {
      const properties = {
        title: '',
        description: '',
      };

      switch (this.fraudRating) {
        case this.options.HIGH_RISK:
          properties.title = 'High Risk';
          properties.description =
            'Inscribe has confidence that one or more of this customer’s documents have been manipulated.';
          break;
        case this.options.LOW_RISK:
          properties.title = 'Low Risk';
          properties.description =
            'Inscribe has confidence in the trustworthiness of all classified documents.';
          break;
        case this.options.UNCERTAIN_RISK:
          properties.title = 'Uncertain Risk';
          properties.description =
            'Inscribe isn’t confident enough to give a definitive rating based on the document types and signals detected.';
          break;
      }

      return properties;
    },
  },
  methods: {
    goToArticle() {
      window.open(
        'https://help.inscribe.ai/en/articles/8631969-fraud-rating',
        '_blank',
        'noopener',
      );
    },
  },
};
</script>

<style lang="scss">
.fraud-rating-badge {
  display: inline-flex !important;
  flex-wrap: nowrap;
}
</style>
